import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../base/root-store';
import {
    Button,
    Grid,
    GridColumn,
    Indicator,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Progress,
    ProgressWithIndicator,
} from '../../../patterns';

export const OnboardingCompanyHelpModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).onboardingStore;

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.label('onboarding.company-help-modal.title')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">
                    <p>{store.label('onboarding.company-help-modal.content-intro')}</p>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-5']}>
                            <ProgressWithIndicator progress = {{
                                color: 'red',
                                indicator: 65,
                                percent: 45,
                            }}
                            indicator={{
                                number: 45,
                                color: 'red',
                            }}/>
                        </GridColumn>
                        <GridColumn width={['xs-7']}>
                            {store.label('onboarding.company-help-modal.content-score')}
                        </GridColumn>
                    </Grid>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-5']}>
                            <Indicator color="green" number={15} isNumberNotVisible={true}/>
                        </GridColumn>
                        <GridColumn width={['xs-7']}>
                            {store.label('onboarding.company-help-modal.content-change')}
                        </GridColumn>
                    </Grid>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-5']} className={'modal__progress-bar'}>
                            <Progress color="blue" percent={75} indicator={75}/>
                        </GridColumn>
                        <GridColumn width={['xs-7']}>
                            {store.label('onboarding.company-help-modal.content-participation')}
                        </GridColumn>
                    </Grid>
                </div>
                <div className="text">
                    <p className="modal__help-link-label">
                        <a href={'https://moticheck.com/kb/'} target={'_blank'} rel="noreferrer">{store.label('common.help-modal.content-help-text-label')}</a>
                    </p>
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['center-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('common.modal.close')}/>
                        </ModalCloser>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
